// Utility functions for managing shopId from URL parameters

const SHOP_ID_STORAGE_KEY = 'taogo-shop-id';

/**
 * Extract shop id from URL query (?id= 为扫码店铺 id，与后端注册 body.id 对应)
 */
export function getShopIdFromUrl(searchParams) {
    return searchParams.get('id');
}

/**
 * Save shopId to localStorage
 * @param {string|number} shopId - The shop ID to store
 */
export function saveShopId(shopId) {
    if (shopId !== null && shopId !== undefined && shopId !== '') {
        localStorage.setItem(SHOP_ID_STORAGE_KEY, String(shopId));
    }
}

/**
 * Get stored shopId from localStorage
 * @returns {string|null} - Stored shopId or null
 */
export function getStoredShopId() {
    return localStorage.getItem(SHOP_ID_STORAGE_KEY);
}

/**
 * Clear stored shopId from localStorage
 */
export function clearShopId() {
    localStorage.removeItem(SHOP_ID_STORAGE_KEY);
}

/**
 * Get shopId from URL or localStorage
 * Priority: URL parameter > localStorage
 * @param {URLSearchParams} searchParams - URL search params object
 * @returns {string|null} - shopId if found, null otherwise
 */
export function getShopId(searchParams) {
    const urlShopId = getShopIdFromUrl(searchParams);
    if (urlShopId) {
        saveShopId(urlShopId);
        return urlShopId;
    }
    return getStoredShopId();
}
